/**
 * Fog of war look (docs/fog-of-war/README.md). Heavy fog: every territory the
 * viewer can't see (and its marker disc) is one light-grey fill under tight
 * diagonal lines, so the map's shape stays readable while the board state is
 * plainly withheld, and no region or owner colour hints at anything. The same
 * colours in light and dark mode (maintainer, 2026-10-30). Light fog shows
 * owners' colours as normal and draws none of this.
 */

/** Fill for a heavy-fog territory or disc. */
export const HEAVY_FOG_FILL = '#c4c1b4'

/** The tight diagonal lines drawn over it. */
export const HEAVY_FOG_LINE = '#99978c'

/** Ids of fogged territories, for the fog layers and badge skipping. */
export function foggedTerritoryIds(territories: ReadonlyArray<{ id: string; fogged?: boolean }>): Set<string> {
  return new Set(territories.filter((t) => t.fogged).map((t) => t.id))
}

/** Territories that were fogged before and are not now (FogLiftLayer fades these). */
export function liftedTerritoryIds(before: ReadonlySet<string>, after: ReadonlySet<string>): string[] {
  return [...before].filter((id) => !after.has(id))
}
